__turbopack_context__.v({
  "className": "caveat_9ae75f03-module__bLjiva__className",
});
